module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-dark"
  }, [(_vm.isAllLoaded && !_vm.salarySystem) ? _c('ChooseSalarySystem', {
    attrs: {
      "schoolId": _vm.schoolId
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-sub-header"
  }, [_c('p', {
    staticClass: "d-sub-header__link",
    class: {
      'd-sub-header__link--active': _vm.activePage === 'tillæg'
    },
    on: {
      "click": function($event) {
        return _vm.setActivePage('tillæg')
      }
    }
  }, [_vm._v("Tillæg\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "d-sub-header__link",
    class: {
      'd-sub-header__link--active': _vm.activePage === 'tillægstyper'
    },
    on: {
      "click": function($event) {
        return _vm.setActivePage('tillægstyper')
      }
    }
  }, [_vm._v("Tillægstyper\n    ")])]), _vm._v(" "), (_vm.isAllLoaded) ? [(_vm.activePage === 'tillæg') ? _c('SupplementsList', {
    attrs: {
      "schoolId": _vm.schoolId,
      "schoolYear": _vm.schoolYear,
      "schoolYearId": _vm.schoolYearId,
      "supplementTypes": _vm.activeSupplementTypes
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activePage === 'tillægstyper') ? _c('SupplementsTypes', {
    attrs: {
      "schoolId": _vm.schoolId,
      "isLoading": _vm.isLoadingSupplementTypes,
      "supplementTypes": _vm.activeSupplementTypes
    },
    on: {
      "readSupplementTypes": _vm.readSupplementTypes
    }
  }) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-35454604!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Supplements/Supplements.vue
// module id = 1582
// module chunks = 1